var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.General.passwordSettingsStartCase")))
      ]),
      _vm._v(" "),
      !_vm.hasPassword
        ? _c(
            "panel-basic",
            {
              attrs: {
                title: _vm.$t("MAIN_CONTENT.General.changeMyPassword"),
                id: "passwordSettings",
                collapsable: true,
                headingLevel: 4
              }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", {
                  staticClass: "col-xs-12",
                  domProps: { innerHTML: _vm._s(_vm.studentSSOMessage) }
                })
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPassword
        ? _c(
            "panel-basic",
            {
              attrs: {
                title: _vm.$t("MAIN_CONTENT.General.changeMyPassword"),
                id: "passwordSettings",
                collapsable: true,
                headingLevel: 4
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.General.changeMyPassword")) +
                    "\n\t\t"
                )
              ]),
              _vm._v(" "),
              !!_vm.passwordFields.responseMessage
                ? _c(
                    "div",
                    {
                      staticClass: "alert",
                      class: {
                        "alert-success":
                          _vm.passwordFields.responseType === "success",
                        "alert-danger":
                          _vm.passwordFields.responseType === "danger"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.passwordFields.responseMessage) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _vm.credType === "LCLPWPIN"
                  ? _c("div", { staticClass: "col-xs-6 col-md-4" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-xs-12" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("MAIN_CONTENT.General.pinWithColon")
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-xs-12" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.passwordFields.pin,
                                expression: "passwordFields.pin"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "password", maxlength: "5" },
                            domProps: { value: _vm.passwordFields.pin },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.passwordFields,
                                  "pin",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-6 col-md-4" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "MAIN_CONTENT.General.oldPasswordStartCaseWithColon"
                            )
                          )
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.passwordFields.oldPassword,
                            expression: "passwordFields.oldPassword"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "password", maxlength: "30" },
                        domProps: { value: _vm.passwordFields.oldPassword },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.passwordFields,
                              "oldPassword",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-6 col-md-4" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("strong", [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.General.newPasswordStartCaseWithColon"
                              )
                            ) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 userWizard" },
                      [
                        _c("password", {
                          ref: "password",
                          staticClass: "password-input",
                          attrs: {
                            name: "password",
                            toggle: true,
                            secureLength: _vm.passwordMinLegth,
                            showStrengthMeter: true,
                            autocomplete: "new-password",
                            maxlength: "40",
                            disabled:
                              (_vm.credType === "LCLPWPIN" &&
                                !_vm.passwordFields.pin) ||
                              !_vm.passwordFields.oldPassword
                          },
                          model: {
                            value: _vm.passwordFields.newPassword,
                            callback: function($$v) {
                              _vm.$set(_vm.passwordFields, "newPassword", $$v)
                            },
                            expression: "passwordFields.newPassword"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-6 col-md-4" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-xs-12" }, [
                      _c("strong", [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.General.confirmNewPasswordStartCaseWithColon"
                              )
                            ) +
                            "\n\t\t\t\t\t\t"
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 userWizard" },
                      [
                        _c("password", {
                          ref: "password",
                          staticClass: "password-input",
                          attrs: {
                            name: "password",
                            toggle: true,
                            secureLength: _vm.passwordMinLegth,
                            showStrengthMeter: true,
                            autocomplete: "new-password",
                            maxlength: "40",
                            disabled:
                              (_vm.credType === "LCLPWPIN" &&
                                !_vm.passwordFields.pin) ||
                              !_vm.passwordFields.oldPassword
                          },
                          model: {
                            value: _vm.passwordFields.confirmNewPassword,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.passwordFields,
                                "confirmNewPassword",
                                $$v
                              )
                            },
                            expression: "passwordFields.confirmNewPassword"
                          }
                        }),
                        _vm._v(" "),
                        (_vm.credType !== "LCLPWPIN" ||
                          _vm.passwordFields.pin) &&
                        _vm.passwordFields.oldPassword &&
                        _vm.passwordFields.newPassword.length > 0 &&
                        _vm.passwordMessage > 0
                          ? _c(
                              "small",
                              { staticClass: "help-block text-danger" },
                              [
                                _vm.passwordMessage === 1
                                  ? _c("span", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "MAIN_CONTENT.General.passwordRequirements"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                      _c("ul", [
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "MAIN_CONTENT.General.passwordLengthMessage",
                                                { length: _vm.passwordMinLegth }
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "MAIN_CONTENT.General.passwordMixMessage"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.passwordMessage === 2
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "MAIN_CONTENT.General.passwordDoesntMatch"
                                          )
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-4 col-xs-offset-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: {
                        disabled:
                          (_vm.credType === "LCLPWPIN" &&
                            !_vm.passwordFields.pin) ||
                          !_vm.passwordFields.oldPassword ||
                          _vm.passwordFields.newPassword !==
                            _vm.passwordFields.confirmNewPassword ||
                          _vm.passwordMessage !== 0
                      },
                      on: { click: _vm.saveNewPassword }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("commonText.save")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPassword
        ? _c("h3", [
            _vm._v(
              _vm._s(
                _vm.$t("MAIN_CONTENT.General.securityQuestionSettingsStartCase")
              )
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPassword
        ? _c(
            "panel-basic",
            {
              attrs: {
                title: _vm.$t("MAIN_CONTENT.General.changeMySecurityQuestion"),
                id: "securityQuestionSettings",
                collapsable: true,
                headingLevel: 4
              }
            },
            [
              _c("template", { slot: "title" }, [
                _vm._v(
                  "\n\t\t\t" +
                    _vm._s(
                      _vm.$t("MAIN_CONTENT.General.changeMySecurityQuestion")
                    ) +
                    "\n\t\t"
                )
              ]),
              _vm._v(" "),
              !!_vm.securityQuestionFields.responseMessage
                ? _c(
                    "div",
                    {
                      staticClass: "alert",
                      class: {
                        "alert-success":
                          _vm.securityQuestionFields.responseType === "success",
                        "alert-danger":
                          _vm.securityQuestionFields.responseType === "danger"
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t" +
                          _vm._s(_vm.securityQuestionFields.responseMessage) +
                          "\n\t\t"
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("strong", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.General.securityQuestionStartCaseWithColon"
                          )
                        ) +
                        "\n\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.securityQuestionFields.question,
                        expression: "securityQuestionFields.question"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", maxlength: "100" },
                    domProps: { value: _vm.securityQuestionFields.question },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.securityQuestionFields,
                          "question",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("strong", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.General.securityAnswerStartCaseWithColon"
                          )
                        ) +
                        "\n\t\t\t\t"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.securityQuestionFields.answer,
                        expression: "securityQuestionFields.answer"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text", maxlength: "100" },
                    domProps: { value: _vm.securityQuestionFields.answer },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.securityQuestionFields,
                          "answer",
                          $event.target.value
                        )
                      }
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-4 col-xs-offset-4" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-default",
                      attrs: {
                        disabled:
                          !_vm.securityQuestionFields.question ||
                          !_vm.securityQuestionFields.answer
                      },
                      on: { click: _vm.saveSecurityQuestions }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("commonText.save")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  )
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.General.generalAccountSettings")))
      ]),
      _vm._v(" "),
      _c(
        "panel-basic",
        {
          attrs: {
            title: _vm.$t("MAIN_CONTENT.General.changeMyAccountSettings"),
            id: "generalAccountSettings",
            collapsable: true,
            headingLevel: 4
          }
        },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("MAIN_CONTENT.General.changeMyAccountSettings")) +
                "\n\t\t"
            )
          ]),
          _vm._v(" "),
          !!_vm.generalAccountSettings.responseMessage
            ? _c(
                "div",
                {
                  staticClass: "alert",
                  class: {
                    "alert-success":
                      _vm.generalAccountSettings.responseType === "success",
                    "alert-danger":
                      _vm.generalAccountSettings.responseType === "danger"
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t" +
                      _vm._s(_vm.generalAccountSettings.responseMessage) +
                      "\n\t\t"
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-12" }, [
              _c("strong", [
                _vm._v(
                  "\n\t\t\t\t\t" +
                    _vm._s(_vm.$t("MAIN_CONTENT.General.selectLanguage")) +
                    "\n\t\t\t\t"
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-xs-12" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedLocale,
                      expression: "selectedLocale"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { name: "localeSelection", id: "localeSelect" },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedLocale = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.locales, function(locale, localeIndex) {
                  return _c(
                    "option",
                    {
                      key: "locale_" + localeIndex,
                      domProps: { value: locale.LOCALE_ID }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t" +
                          _vm._s(locale.LOCALE_DISPLAY_TEXT) +
                          "\n\t\t\t\t\t"
                      )
                    ]
                  )
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-xs-4 col-xs-offset-4" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-default",
                  on: { click: _vm.saveAccountSettings }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.$t("commonText.save")) +
                      "\n\t\t\t\t"
                  )
                ]
              )
            ])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }